import React from 'react';
import { LoginSitePickerComponent } from '~src/common/react/components/LoginSitePickerComponent';
import { MobileAppBanner } from '../../../mobile/components/MobileAppBanner';
import { AngularContext } from '../../../ts/factories/AngularContextFactory';
import { ProcessAndRemoveSamlQueryWrapper } from '../RouterHelpers/ProcessAndRemoveSamlQueryWrapper';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';


export function SitePickerProvider(props: {angularContext: AngularContext}): JSX.Element {
  return (
    <DefaultServerTitleWrapper>
      <ProcessAndRemoveSamlQueryWrapper>
        <div>
          <MobileAppBanner />
        </div>
        <div>
          <LoginSitePickerComponent/>
        </div>
      </ProcessAndRemoveSamlQueryWrapper>
    </DefaultServerTitleWrapper>
  );
}
